$(function() {
    $('*[data-action=logout]').on('click', function(){
        Manogi.logout();
    });
});
